import React, { useState, useEffect } from 'react';
import axios from "axios";
import { useNavigate } from "react-router-dom"; // Need this for navigation
import { useAppId } from "../../context/AppIdContext";
import Header from '../../component/header';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const BoothWiseSlipSendDash = () => {
    // --- Logic State ---
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");

    // --- Mobile Search State ---
    const [isMobileSearchOpen, setIsMobileSearchOpen] = useState(false);

    // Get context variables and navigate
    const { appId, language } = useAppId();
    const navigate = useNavigate(); // --- ADDED NAVIGATE HOOK ---

    const lang = language || 'en';

    // Translation dictionary
    const t = {
        en: {
            title: "Booth Wise Slip Status",
            subtitle: "View slip sending statistics for each booth.",
            searchPlaceholder: "Search by booth number...",
            totalVoters: "Total",
            sent: "Send",
            remaining: "Remaining",
            boothLabel: "Booth No:",
            noRecordsFound: "No booths found matching",
            loading: "Loading Dashboard Data..."
        },
        hi: {
            title: "बूथ वार पर्ची स्थिति",
            subtitle: "प्रत्येक बूथ के लिए पर्ची भेजने के आंकड़े देखें।",
            searchPlaceholder: "बूथ नंबर से खोजें...",
            totalVoters: "कुल",
            sent: "भेजा गया",
            remaining: "शेष",
            boothLabel: "बूथ नं:",
            noRecordsFound: "कोई बूथ नहीं मिला",
            loading: "डेटा लोड हो रहा है..."
        },
        gu: {
            title: "બૂથ મુજબ સ્લિપ સ્ટેટસ",
            subtitle: "દરેક બૂથ માટે સ્લિપ મોકલવાના આંકડા જુઓ.",
            searchPlaceholder: "બૂથ નંબર દ્વારા શોધો...",
            totalVoters: "કુલ",
            sent: "મોકલેલ",
            remaining: "બાકી",
            boothLabel: "બૂથ નં:",
            noRecordsFound: "કોઈ બૂથ મળ્યું નથી",
            loading: "ડેશબોર્ડ ડેટા લોડ થઈ રહ્યો છે..."
        }
    };

    const txt = t[lang] || t['en'];

    // --- API Fetching ---
    useEffect(() => {
        if (appId) {
            fetchDashboardData();
        }
    }, [appId]);

    const fetchDashboardData = async () => {
        setLoading(true);
        try {
            const response = await axios.post(
                `${BASE_URL}/api/dis_booth_wise_slip_send_dash`,
                { app_id: appId }
            );

            if (response.data.success && response.data.data && response.data.data.result) {
                setData(response.data.data.result);
            }
        } catch (err) {
            console.error("API Error:", err);
        } finally {
            setLoading(false);
        }
    };

    // Filter Logic
    const filteredData = data.filter(item => {
        if (!searchTerm) return true;
        // Search by booth number
        return String(item.booth_no).includes(searchTerm);
    });

    if (loading) {
        return (
            <div className="loader-wrapper">
                <div className="spinner"></div>
                <p className="loader-text">{txt.loading}</p>
                <style jsx>{`
                    .loader-wrapper { display: flex; flex-direction: column; justify-content: center; align-items: center; min-height: 60vh; width: 100%; }
                    .spinner { width: 50px; height: 50px; border: 4px solid #E5E7EB; border-top: 4px solid #2563EB; border-radius: 50%; animation: spin 1s linear infinite; margin-bottom: 16px; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1); }
                    .loader-text { color: #6B7280; font-weight: 500; font-size: 1.1rem; animation: pulse 1.5s ease-in-out infinite; }
                    @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
                    @keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.5; } }
                `}</style>
            </div>
        );
    }

    return (
        <>
            <div className="app-container p-4">
                <Header title={txt.title}/>

                {/* Styled Filter Bar */}
                <div className="filter-container mt-3">
                    <div className={`search-wrapper mobile-open`}>
                        <svg className="search-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                        <input
                            type="text"
                            className="search-input"
                            placeholder={txt.searchPlaceholder}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        
                    </div>


                </div>

                {/* Dashboard Grid - Image Style */}
                <div className="dashboard-grid">
                    {filteredData.length > 0 ? (
                        filteredData.map((item, index) => {
                            // Calculate percentage for progress circle
                            const rawPercentage = item.total_voter > 0 ? (item.send / item.total_voter) * 100 : 0;
                            const percentage = rawPercentage.toFixed(1); // Keep one decimal like '1.0%'

                            // SVG Circle Math
                            const sqSize = 120;
                            const strokeWidth = 10;
                            const radius = (sqSize - strokeWidth) / 2;
                            const viewBox = `0 0 ${sqSize} ${sqSize}`;
                            const dashArray = radius * Math.PI * 2;
                            const dashOffset = dashArray - (dashArray * rawPercentage) / 100;

                            return (
                                <div 
                                    key={index} 
                                    className="booth-circle-card"
                                    // --- THE FIX: ADDED onClick NAVIGATION HERE ---
                                    onClick={() => navigate('/booth_wise_slip_sending', { state: { booth_no: item.booth_no } })}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <h3 className="booth-title">{txt.boothLabel} {item.booth_no}</h3>
                                    
                                    <div className="circle-container">
                                        <svg width={sqSize} height={sqSize} viewBox={viewBox}>
                                            <circle
                                                className="circle-background"
                                                cx={sqSize / 2}
                                                cy={sqSize / 2}
                                                r={radius}
                                                strokeWidth={strokeWidth}
                                            />
                                            <circle
                                                className="circle-progress"
                                                cx={sqSize / 2}
                                                cy={sqSize / 2}
                                                r={radius}
                                                strokeWidth={strokeWidth}
                                                transform={`rotate(-90 ${sqSize / 2} ${sqSize / 2})`}
                                                style={{
                                                    strokeDasharray: dashArray,
                                                    strokeDashoffset: dashOffset
                                                }}
                                            />
                                            <text
                                                className="circle-text"
                                                x="50%"
                                                y="50%"
                                                dy=".3em"
                                                textAnchor="middle"
                                            >
                                                {percentage}%
                                            </text>
                                        </svg>
                                    </div>

                                    <div className="booth-stats-bottom">
                                        <div className="stat-column text-left">
                                            <span className="stat-label">{txt.totalVoters}</span>
                                            <span className="stat-value">{item.total_voter}</span>
                                        </div>
                                        <div className="stat-column text-right">
                                            <span className="stat-label">{txt.sent}</span>
                                            <span className="stat-value">{item.send}</span>
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <div className="no-results" style={{ gridColumn: "1 / -1", textAlign: "center", padding: "40px", color: "#6b7280" }}>
                            {txt.noRecordsFound} "{searchTerm}"
                        </div>
                    )}
                </div>
            </div>

            <style jsx>{`
                /* --- APP CONTAINER --- */
                .app-container {
                    background: #E5E7EB;
                    min-height: 100vh;
                    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
                }

                /* --- PROFESSIONAL FILTER CONTAINER --- */
                .filter-container {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    gap: 16px;
                    margin-bottom: 24px;
                    background: transparent;
                }

                .action-group {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                }

               
                .close-search-btn { display: none; }

                .search-wrapper {
                    position: relative;
                    flex: 1;
                    max-width: 400px;
                }

                .search-icon {
                    position: absolute;
                    left: 14px;
                    top: 50%;
                    transform: translateY(-50%);
                    color: #94a3b8;
                    width: 20px;
                    height: 20px;
                }

                .search-input {
                    width: 100%;
                    padding: 12px 16px 12px 42px;
                    border: 1px solid #e2e8f0;
                    border-radius: 10px;
                    font-size: 14px;
                    color: #1e293b;
                    background-color: #ffffff;
                    outline: none;
                    transition: all 0.2s ease;
                    box-shadow: 0 1px 2px rgba(0,0,0,0.05);
                }

                .search-input:focus {
                    border-color: #2563eb;
                    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
                }

                /* --- DASHBOARD GRID & NEW CARDS --- */
                .dashboard-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
                    gap: 24px;
                    margin-top: 20px;
                }

                .booth-circle-card {
                    background: #ffffff;
                    border-radius: 12px;
                    padding: 24px 20px;
                    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    transition: all 0.3s ease;
                    border: 1px solid #f1f5f9;
                }

                .booth-circle-card:hover {
                    transform: translateY(-4px);
                    box-shadow: 0 12px 20px -5px rgba(0, 0, 0, 0.08);
                }

                .booth-title {
                    font-size: 17px;
                    font-weight: 800;
                    color: #1e293b;
                    margin: 0 0 24px 0;
                    text-align: center;
                }

                /* Circular Progress Styles */
                .circle-container {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-bottom: 24px;
                }

                .circle-background {
                    fill: none;
                    stroke: #f1f5f9;
                }

                .circle-progress {
                    fill: none;
                    stroke: #8B5CF6; /* Reddish color from image */
                    stroke-linecap: round;
                    transition: stroke-dashoffset 0.8s ease;
                }

                .circle-text {
                    font-size: 20px;
                    font-weight: 700;
                    fill: #8B5CF6;
                }

                /* Stats Footer */
                .booth-stats-bottom {
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                    padding: 0 10px;
                }

                .stat-column {
                    display: flex;
                    flex-direction: column;
                }

                .text-left { text-align: left; }
                .text-right { text-align: right; }

                .stat-label {
                    font-size: 14px;
                    font-weight: 600;
                    color: #94a3b8;
                    margin-bottom: 4px;
                }

                .stat-value {
                    font-size: 16px;
                    font-weight: 800;
                    color: #1e293b;
                }

                /* Mobile Optimization */
                @media (max-width: 640px) {
                    .filter-container { flex-direction: row; align-items: center; gap: 8px; }
                    .search-wrapper { display: none; flex: 1; max-width: none; }
                    .search-wrapper.mobile-open { display: block; }
                    .search-input { padding: 10px 16px 10px 36px; font-size: 13px; padding-right: 40px; }
                    .search-icon { left: 10px; width: 16px; height: 16px; }
                    
                    .close-search-btn { 
                        display: block; 
                        position: absolute; 
                        right: 8px; 
                        top: 50%; 
                        transform: translateY(-50%); 
                        background: #f1f5f9; 
                        border: none; 
                        color: #64748b; 
                        padding: 4px; 
                        border-radius: 50%; 
                        cursor: pointer; 
                        display: flex; 
                        align-items: center; 
                        justify-content: center; 
                        z-index: 2; 
                    }
                    
                    .action-group { width: auto; flex-shrink: 0; }
                    
                    .mobile-search-trigger { 
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background: white;
                        border: 1px solid #e2e8f0;
                        border-radius: 10px;
                        width: 46px;
                        height: 46px;
                        color: #64748b;
                        cursor: pointer;
                        box-shadow: 0 1px 2px rgba(0,0,0,0.05);
                    }

                    .dashboard-grid { 
                        grid-template-columns: repeat(auto-fill, minmax(160px, 1fr)); 
                        gap: 16px; 
                    }

                    .booth-circle-card {
                        padding: 20px 16px;
                    }

                    .booth-title {
                        font-size: 15px;
                        margin-bottom: 16px;
                    }
                }
            `}</style>
        </>
    );
};

export default BoothWiseSlipSendDash;